@if (!packageService.tripFlightsLoading) {
    @if (packageService.tripFlights; as flights) {
        <div class="kiwi-box">
            <div class="kiwi-box__fields">
                <div class="field-box from">
                    <div class="field-box__label">From</div>
                    <div class="field-box__input">
                        <div class="input-field input-field--writable">
                            <input [formControl]="searchForm"
                                   [matAutocomplete]="auto"
                                   class="dialog__input"
                                   placeholder="Type destination/city name"
                            />
                            <mat-autocomplete #auto="matAutocomplete">
                                @for (option of startInGroup; track $index) {
                                  @if (option && option.isDisabled) {
                                      <mat-option class="error-option">
                                        We currently don’t support this destination
                                      </mat-option>
                                  } @else {
                                      <mat-option [value]="option.name" (click)="addStartIn(option)">
                                        <span [innerHTML]="option.name"></span>
                                      </mat-option>
                                  }
                                }
                            </mat-autocomplete>
                        </div>
                    </div>
                </div>
                <div class="kiwi-box__fields__arrow">
                    <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_LONG"></mat-icon>
                </div>
                <div class="field-box to">
                    <div class="field-box__label">To</div>
                    <div class="field-box__input">
                        {{ flights[0].outbound.segment[flights[0].outbound.segment.length - 1].arrival.city }}
                    </div>
                </div>
                <div class="field-box">
                    <div class="field-box__label">Departue</div>
                    <div class="field-box__input">
                        {{ flights[0].outbound.dates.from | date: 'ccc dd MMM, yyyy' }}
                    </div>
                </div>
                <div class="field-box">
                    <div class="field-box__label">Return</div>
                    <div class="field-box__input">
                        {{ flights[0].inbound.dates.from | date: 'ccc dd MMM, yyyy' }}
                    </div>
                </div>
                <button
                        class="btn-default btn-primary white-link"
                        [class.disabled]="packageService.disableSearchButtonStatus"
                        (click)="clickSearchFlight()">
                    Search flight
                </button>
            </div>
            @for (k of flights; track $index) {
                <div class="kiwi-box__flights">
                    @if (k.outbound; as out) {
                        <div class="kiwi-box__flight">
                            @for (s of out.segment; track $index; let first = $first) {
                                <div class="kiwi-box__segment">
                                    @if(breakpointService.isDesktop()) {
                                      <span class="carrier-logo" [attr.data-name]="s.carriername">
                                        <img [attr.src]="s.carrierlogo" [alt]="s.carriername">
                                      </span>
                                      <div class="info-box">
                                        <p>{{ s.departure.time | cutStr: 5 }}</p>
                                        <p>{{ s.departure.city }}</p>
                                      </div>
                                      <div class="duration-box">
                                        <div class="duration-box__point">
                                          <span>{{ s.departure.date | date: 'dd MMM' }}</span>
                                          <span>{{ out.traveltime }}</span>
                                          <span>{{ s.arrival.date | date: 'dd MMM' }}</span>
                                        </div>
                                        <div class="duration-box__line"></div>
                                        <div class="duration-box__point with-padding">
                                          <span>{{ s.departure.terminal }}</span>
                                          <span>{{ s.arrival.terminal }}</span>
                                        </div>
                                      </div>
                                      <div class="info-box">
                                        <p>{{ s.arrival.time | cutStr: 5 }}</p>
                                        <p>{{ s.arrival.city }}</p>
                                      </div>
                                    } @else {
                                      <div class="kiwi-box__segment--container">
                                        <figure class="kiwi-box__segment--figure">
                                          <img [attr.src]="s.carrierlogo | safeUrl" [alt]="s.carriername">
                                        </figure>
                                        <div class="kiwi-box__segment--info">
                                          <div class="kiwi-box__segment--row">
                                            <div class="kiwi-box__segment--col">
                                              <p class="kiwi-box__segment--time kiwi-box__segment--left">{{ s.departure.time | cutStr: 5 }}</p>
                                              <p class="kiwi-box__segment--city kiwi-box__segment--left">{{ s.departure.city }}</p>
                                            </div>
                                            <div class="kiwi-box__segment--col kiwi-box__segment--flex">
                                              <p class="kiwi-box__segment--duration">
                                                <span>{{ out.traveltime }}</span>
                                              </p>
                                              <p class="kiwi-box__segment--duration">
                                                <span>{{ s.departure.date | date: 'dd MMM' }} - {{ s.arrival.date | date: 'dd MMM' }}</span>
                                              </p>
                                            </div>
                                            <div class="kiwi-box__segment--col">
                                              <p class="kiwi-box__segment--time kiwi-box__segment--right">{{ s.arrival.time | cutStr: 5 }}</p>
                                              <p class="kiwi-box__segment--city kiwi-box__segment--right">{{ s.arrival.city }}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                </div>
                            }

                        </div>
                    }


                    @if (k.inbound; as inb) {
                        <div class="kiwi-box__flight">
                            @for (s of inb.segment; track $index; let first = $first) {
                              @if(breakpointService.isDesktop()) {
                                <div class="kiwi-box__segment">
                                    <span class="carrier-logo" [attr.data-name]="s.carriername">
                                        <img [attr.src]="s.carrierlogo" [alt]="s.carriername">
                                    </span>
                                  <div class="info-box">
                                    <p>{{ s.departure.time | cutStr: 5 }}</p>
                                    <p>{{ s.departure.city }}</p>
                                  </div>
                                  <div class="duration-box">
                                    <div class="duration-box__point">
                                      <span>{{ s.departure.date | date: 'dd MMM' }} </span>
                                      <span>{{ inb.traveltime }}</span>
                                      <span> {{ s.arrival.date | date: 'dd MMM' }}</span>
                                    </div>
                                    <div class="duration-box__line"></div>
                                    <div class="duration-box__point with-padding">
                                      <span>{{ s.departure.terminal }}</span>
                                      <span>{{ s.arrival.terminal }}</span>
                                    </div>
                                  </div>
                                  <div class="info-box">
                                    <p>{{ s.arrival.time | cutStr: 5 }}</p>
                                    <p>{{ s.arrival.city }}</p>
                                  </div>
                                </div>
                              } @else {
                                <div class="kiwi-box__segment--container">
                                  <figure class="kiwi-box__segment--figure">
                                    <img [attr.src]="s.carrierlogo | safeUrl" [alt]="s.carriername">
                                  </figure>
                                  <div class="kiwi-box__segment--info">
                                    <div class="kiwi-box__segment--row">
                                      <div class="kiwi-box__segment--col">
                                        <p class="kiwi-box__segment--time kiwi-box__segment--left">{{ s.departure.time | cutStr: 5 }}</p>
                                        <p class="kiwi-box__segment--city kiwi-box__segment--left">{{ s.departure.city }}</p>
                                      </div>
                                      <div class="kiwi-box__segment--col kiwi-box__segment--flex">
                                        <p class="kiwi-box__segment--duration">
                                          <span>{{ inb.traveltime }}</span>
                                        </p>
                                        <p class="kiwi-box__segment--duration">
                                          <span>{{ s.departure.date | date: 'dd MMM' }} - {{ s.arrival.date | date: 'dd MMM' }}</span>
                                        </p>
                                      </div>
                                      <div class="kiwi-box__segment--col">
                                        <p class="kiwi-box__segment--time kiwi-box__segment--right">{{ s.arrival.time | cutStr: 5 }}</p>
                                        <p class="kiwi-box__segment--city kiwi-box__segment--right">{{ s.arrival.city }}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            }

                        </div>
                    }

                    @if(breakpointService.isDesktop()) {
                      <a [href]="k.link" (click)="clickBookFLight()" class="btn-default btn-primary--outline"
                         target="_blank">
                        Book {{ k.price.currency.sign }}{{ k.price.visible }}
                      </a>
                    } @else {
                      <a [href]="k.link" (click)="clickBookFLight()" class="btn-default btn-blue btn-booking"
                         target="_blank">
                        Select {{ k.price.currency.sign }}{{ k.price.visible }}
                      </a>
                    }
                </div>
            }
            <a class="show-more-flights" target="_blank" [attr.href]="kiwiLink" (click)="clickShowMore()">
                Show more
            </a>
        </div>
    } @else {
        <h4 class="kiwi-box__no-tickets">No ticket found</h4>
    }
} @else {
    <div class="kiwi-box">
        <div class="kiwi-box__loader">
            <img src="assets/icon/loader-walker1.gif" alt="loader icon">
            <p class="kiwi-box__loader__text"></p>
        </div>
    </div>
}
